export default "__VITE_PUBLIC_ASSET__530e4fe3__"